import React from "react";
import { truncate } from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";

function Ledger(props) {
  let gridVal = props.gridVal;

  const showLedgerData = (gridVal) => {
    return (
      gridVal &&
      gridVal.map((item, key) => {
        return (
          <tr key={key}>
            <td>
              {item.voucherDate === "" || undefined || null
                ? "-"
                : item.voucherDate}
            </td>
            <td>
              {item.effectiveDate === "" || undefined || null
                ? "-"
                : item.effectiveDate}
            </td>
            <td>
              {item.exchange === "" || undefined || null ? "-" : item.exchange}
            </td>

            <td>
              {item.voucherType === "" || undefined || null
                ? "-"
                : item.voucherType}
            </td>
            <td className="tooltip123">
              {truncate(
                item.narration === "" || undefined || null
                  ? "-"
                  : item.narration
              )}
              <span className="tooltiptext">
                {item.narration === "" || undefined || null
                  ? "-"
                  : item.narration}
              </span>
            </td>
            <td>
              {item.chequeDDNo === "" || undefined || null
                ? "-"
                : item.chequeDDNo}
            </td>

            <td>{item.debit === "" || undefined || null ? "-" : item.debit}</td>
            <td>
              {item.credit === "" || undefined || null ? "-" : item.credit}
            </td>
            <td>
              {item.balance === "" || undefined || null ? "-" : item.balance}
            </td>
          </tr>
        );
      })
    );
  };
  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper">
        {gridVal && gridVal.length > 0 ? (
          <table className="table leger-report">
            <thead>
              <tr>
                <th scope="col" className="">
                  {Constants.Voucher_Date}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Effective_Date}
                </th>
                <th scope="col">EXCH./SEG</th>

                <th scope="col" className="text-center">
                  {Constants.Voucher_Type}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Narration}
                </th>
                <th scope="col" className="text-center">
                  Cheque No
                </th>

                <th scope="col" className="text-center">
                  {Constants.Debit}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Credit}
                </th>
                <th scope="col" className="text-center">
                  Running Balance
                </th>
              </tr>
            </thead>
            <tbody>{showLedgerData(gridVal)}</tbody>
          </table>
        ) : (
          <div className="report-error-message">
            {Constants.Ledger_Report_doesnt_exist}
          </div>
        )}
      </div>
    </>
  );
}
export default Ledger;
